if ($('blockquote[data-desktop-src]').length) {
  $('blockquote[data-desktop-src]').each(function () {
    if ($(this).attr('data-desktop-src') !== '' || $(this).attr('data-theme') !== '') {
      $(this).addClass('image-quote');
      var quote = $(this).html();
      $(this).html('');
      $(this).append('<p>' + quote + '</p>');
    }

    if ($(this).attr('data-desktop-src') !== '') {
      if ($(window).width() < 668 && $(this).attr('data-mobile-src')) {
        $(this).append('<div class="image-quote__background" style="background-image: url(\'' + $(this).attr('data-mobile-src') + '\')"></div>');
      } else {
        $(this).append('<div class="image-quote__background" style="background-image: url(\'' + $(this).attr('data-desktop-src') + '\')"></div>');
      }
    }

    if ($(this).attr('data-theme') !== '') {
      $(this).append('<div class="image-quote__color" style="background-color:' + $(this).attr('data-theme') + '"></div>');
    }
  });
}